import {Role} from '../helpers/role';
import {Customs} from '../helpers/customs';
import { LLMProvider } from './LLMProvider';

export class User {
    userId: number;
    title: string;
    firstName: string;
    lastName: string;
    emailAddress: string;

    city: string;
    state: string;
    phone: string;
    fax: string;

    userName: string;
    password: string;

    secretQuestion1: string;
    secretAnswer1: string;
    secretQuestion2: string;
    secretAnswer2: string;
    secretQuestion3: string;
    secretAnswer3: string;

    role: Role;
    active: boolean;
    token: string;
    tokens : any;

    isCurrentUser: boolean;

    tenantName: string;

    companyName: string;
    companyAddress: string;

  // @ts-ignore
  fullName: string = this.firstName && this.lastName
    // @ts-ignore
                            ? this.firstName + ' ' + this.lastName
    // @ts-ignore
    : this.emailAddress;

    projectControlItemsColumns: any;

    customs: Customs;
    isChangePasswordRequired: boolean;

    department: number;
  lastLoginTime: string | Date;
  previousLoginTime: string;
  enableMfa: boolean;
  firstLogin: boolean;

  llmProviders: LLMProvider[];
    constructor(userId: number){
        this.userId = userId;
    }
}
